<template>
  <div v-if="timeElapsed">
    <div class="text-center">
      <div class="flex justify-center">
        <img
          src="@/assets/svg/timer.svg"
          alt="timer"
          class="bg-grey-6 p-6 w-16 rounded-3xl"
        />
      </div>
      <p class="font-bold text-lg text-grey-2 mb-9 mt-6">
        {{ $t('errors.auto_logout.title') }} {{ formattedTime }}
      </p>
    </div>
    <div class="text-left" id="popup-auto-logout">
      <p class="text-sm text-grey-2 text-opacity-60">
        {{ $t('errors.auto_logout.description') }}
        <strong> {{ formattedTime }} </strong>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    timeElapsed: {
      type: Number,
      default: 0
    }
  },
  computed: {
    formattedTime() {
      const total = Math.max(this.timeElapsed, 0)
      const minutes = Math.floor(total / 60)
      const seconds = String(total % 60).padStart(2, '0')
      return `${minutes}:${seconds}`
    }
  }
}
</script>
